const SET_PAGE = 'SET_PAGE';
const SET_TYPE = 'SET_TYPE';
const SET_NAME = 'SET_NAME';
const SET_IDCUSTOMER = 'SET_IDCUSTOMER';
const SET_REFERENTIAL_TYPE = 'SET_REFERENTIAL_TYPE';

const REDUCER_ACTIONS = {
  SET_PAGE,
  SET_TYPE,
  SET_NAME,
  SET_IDCUSTOMER,
  SET_REFERENTIAL_TYPE,
}
export default REDUCER_ACTIONS;
